module.exports = __webpack_public_path__ + "assets/images/boundaries/keys-east-west-coast/key-2-2020.svg?v=382857c9";